import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { finalize } from 'rxjs';

import {
  CheckPolygonHaveCellDto,
  SmsAggregator,
} from 'src/app/core/api/models';
import { SmartSmsService } from 'src/app/core/api/services';
import { ShareDirectivesModule } from 'src/app/core/directives/directives.module';
import { FormBtnsModule } from 'src/app/shared/global/form-btns/form-btns.module';
import { ModalTitleComponent } from 'src/app/shared/global/modal-title/modal-title.component';
import { MaterialModule } from 'src/app/shared/modules/material/material.module';

@Component({
  selector: 'app-cell-list',
  templateUrl: './cell-list.component.html',
  styleUrls: ['./cell-list.component.scss'],
  imports: [
    CommonModule,
    MaterialModule,
    NgbModule,
    FormsModule,
    ShareDirectivesModule,
    ReactiveFormsModule,
    TranslateModule,
    FormBtnsModule,
    ModalTitleComponent,
  ],
})
export class CellListComponent implements OnInit {
  //#region Properties
  operators: Array<SmsAggregator> = [];
  polygon: Array<Array<number>>;
  loading: boolean = false;
  items: CheckPolygonHaveCellDto[] = [];
  get SmsAggregator() {
    return SmsAggregator;
  }
  //#endregion

  constructor(
    private smartSmsService: SmartSmsService,
    private dialogRef: MatDialogRef<CellListComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.operators = data?.operators;
    this.polygon = data?.polygon;
  }

  ngOnInit() {
    this.checkPolygonHaveCellApi();
  }

  checkPolygonHaveCellApi() {
    this.loading = true;
    this.smartSmsService
      .smartSmsCheckPolygonHaveCell({
        body: {
          mobileOperators: this.operators,
          polygon: this.polygon,
        },
      })
      .pipe(finalize(() => (this.loading = false)))
      .subscribe((items) => {
        this.items = items?.data;
      });
  }

  onClose() {
    this.dialogRef.close({ isSuccess: false });
  }

  getSmsAggregatorImg(aggregators: SmsAggregator): string {
    try {
      let imgSrc = '';
      switch (aggregators) {
        case SmsAggregator.MCI:
          imgSrc = '/assets/media/svg/operator/mci.svg';
          break;
        case SmsAggregator.Irancell:
          imgSrc = '/assets/media/svg/operator/mtn.svg';
          break;
        case SmsAggregator.Rightel:
          imgSrc = '/assets/media/svg/operator/rightel.svg';
          break;
        case SmsAggregator.NotValid:
          imgSrc = '/assets/media/icons/duotune/general/gen034.svg';
          break;
        case SmsAggregator.Other:
          imgSrc = '/assets/media/icons/duotune/general/gen023.svg';
          break;
        default:
          break;
      }
      return imgSrc;
    } catch (error) {
      console.log('error', error);
    }
  }

  // getSmsAggregatorImgWidth(aggregator: SmsAggregator): string {
  //   try {
  //     let imgWidth = '';
  //     switch (aggregator) {
  //       case SmsAggregator.MCI:
  //         imgWidth = '30';
  //         break;
  //       case SmsAggregator.Irancell:
  //         imgWidth = '30';
  //         break;
  //       case SmsAggregator.Rightel:
  //         imgWidth = '60';
  //         break;
  //       case SmsAggregator.NotValid:
  //         imgWidth = '30';
  //         break;
  //       case SmsAggregator.Other:
  //         imgWidth = '30';
  //         break;
  //       default:
  //         break;
  //     }
  //     return imgWidth;
  //   } catch (error) {
  //     console.log('error', error);
  //   }
  // }

  onSuccess() {
    this.dialogRef.close(true);
  }
}
